import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SettingsUsersState {
  showDisabledUsers: boolean;
}

const initialState: SettingsUsersState = {
  showDisabledUsers: false,
};

const settingsUsersSlice = createSlice({
  name: 'settingsUsers',
  initialState,
  reducers: {
    setShowDisabledUsers: (state, action: PayloadAction<boolean>) => {
      state.showDisabledUsers = action.payload;
    },
  },
});

export const { setShowDisabledUsers } = settingsUsersSlice.actions;

export const settingsUsersReducer = settingsUsersSlice.reducer;
